import { KIT } from "@/constants/testIds";

/** Progress at a glance. The track stays clearly visible at 0% so an unstarted plan still reads. */
export const ProgressRing = ({ value = 0, size = 64, label, tone = "light" }) => {
  const stroke = size > 70 ? 8 : 8;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const clamped = Math.max(0, Math.min(100, value));

  return (
    <div
      data-testid={KIT.progressRing}
      role="progressbar"
      aria-valuenow={Math.round(clamped)}
      aria-valuemin={0}
      aria-valuemax={100}
      className="relative grid shrink-0 place-items-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          strokeWidth={stroke}
          stroke={tone === "dark" ? "rgba(255,255,255,0.18)" : "#EEE9DE"}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={c - (clamped / 100) * c}
          stroke="#DD4115"
          style={{ transition: "stroke-dashoffset 0.7s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <span
        className={`absolute font-display font-extrabold ${tone === "dark" ? "text-white" : "text-brand-teal"} ${
          size > 70 ? "text-[15px]" : "text-[13px]"
        }`}
      >
        {label ?? `${Math.round(clamped)}%`}
      </span>
    </div>
  );
};
